export default __webpack_public_path__ + "static/media/main-logo-black.88d26a37.svg";